<app-navbar></app-navbar>
<div
  class="card"
  style="
    padding: 20px; //background-image: url('assets/img/school/bg.png');
    background-color: #005a63;
    background-size: 100px;
    background-attachment: fixed;
  "
>
  <h2 style=" color: white; text-align:  center; margin-bottom: 10px">Psychology</h2>
  <div>
    <img
      class="img-fluid"
      style="height: 500px; width: 100%; object-fit: cover; border-radius: 10px"
      src="assets/img/school/psychology.jpg"
    />
  </div>
  <br />
  <br />
  <div class="container" style="text-align: justify !important">
    <div class="row">
      <div class="col-md-12">
        <p style="color: white;">
          <strong> PSYCHOLOGY UNIT</strong> <br />
          Psychology is the study of the biological, social, and environmental
          influences that affect how people think, behave, and learn. Psychology
          has important contributions to understanding, explanation, prediction,
          control, and solves problems of special needs children. Psychologists
          apply psychology theories in understanding, explanation, prediction,
          control, and solve problems of special needs children. In
          Proyash-Chattogram, a qualified and trained psychologist work
          dedicatedly since 2015.<br />
          Our Psychologist collaborate with educators, parents, and other
          professionals to create safe, healthy, and supportive learning
          environments for all students that strengthen connections between home
          and school. They also work to provide training to teachers in
          effective teaching strategies, positive behavior support and prevent
          social, environmental, and educational issues.<br />
          Psychologists generally start their approach by completing an
          assessment and understanding the needs of the children. In
          Proyash-Chattogram, our Psychologist administers standardized tests
          and International standard assessment tools to assess.<br />
          <strong>Assessment for a variety of purpose including: </strong>
          <br />
          • Formal diagnosis (e.g. Autism, Intellectual disability)<br />
          • Identifying Functional Capacity<br />
          • Academic progress<br />
          • Mental Health<br /><br />
          <strong
            >The psychologist assesses children with disabilities to progress in
            these areas: </strong
          ><br />
          • Learning, thinking and problem-solving<br />
          • Play skills (for child clients)<br />
          • Social skills<br />
          • Emotional literacy and regulation skills<br />
          • Behavioral challenges<br />
          • Skills for independence<br />
          • General Wellbeing<br />
          The aim of our assessment process is to formulate an understanding of
          the presenting issues that will guide the best course of
          intervention.<br />
          For the intervention psychologist work face-to-face with children,
          families and schools to manage crises. They help to solve conflicts
          and problems in learning and adjustment, Provide social skills
          training, behavior management, and other strategies.<br />
          <strong
            >Psychologists assist children with disabilities in a variety of
            presenting issues. Some include: </strong
          ><br />
          • Adjustment to disability<br />
          • Challenging behaviors<br />
          • Communication<br />
          • Coping skills<br />
          • Play skills<br />
          • Social Skill<br />
          • Development of self-care skills (e.g. toileting, dressing, eating,
          sleep)<br />
          • Parenting support<br />
          • Transition planning<br />
          We use evidenced based interventions to assist people to achieve their
          goals and outcomes. Our psychologist also provide above all the
          services in outdoor service.
        </p>
      </div>
    </div>
  </div>
</div>
